import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { baseURLRoute } from './constants/routeConstants'
import { toastError } from './util/toastUtil'

export const useCustomAxios = () => {
    // Get access to the useNavigate hook from React Router.
    const navigate = useNavigate()

    // Create an Axios instance.
    const axiosInstance = axios.create({
        // Set the base URL for the Axios instance.
        baseURL: process.env.REACT_APP_API_BASE_URL,
    })

    // Add a request interceptor to the Axios instance.
    axiosInstance.interceptors.request.use(
        (config) => {
            // Retrieve the 'user' data from sessionStorage.
            const user = sessionStorage.getItem('user')
            const resetPassToken = sessionStorage.getItem('resetPassToken')

            // If the 'user' data exists in sessionStorage, add it as the Authorization Bearer token.
            if (user) {
                let token = JSON.parse(user).accessToken
                config.headers.Authorization = `Bearer ${token}` // Set the token as a Bearer token in the Authorization header
            }

            if (resetPassToken) {
                config.headers.Authorization = `Bearer ${resetPassToken}` // Set the token as a Bearer token in the Authorization header
            }

            // Return the modified config.
            return config
        },
        (error) => {
            // Handle request errors here.
            return Promise.reject(error)
        }
    )

    // Add a response interceptor to the Axios instance.
    axiosInstance.interceptors.response.use(
        (response) => {
            // If the response is successful, return it as-is.
            return response
        },
        (error) => {
            // If the response contains a specific error related to the authentication token,
            // replace the current page with the login page.
            if (error.response && error.response.status === 401) {
                // Status 401 (Unauthorized)
                // Replace the current page with the login page.
                sessionStorage.clear()
                navigate(baseURLRoute, { replace: true })
                toastError('Session timed out.')
            }

            // Otherwise, return the error as-is.
            return Promise.reject(error)
        }
    )
    return axiosInstance
}
